import { Checkbox } from "@/components/ui/checkbox";

const Enlace = ({ to, id, children }) => (
  <a href={to} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#0284C7] hover:underline" data-testid={id}>{children}</a>
);

function Casilla({ id, checked, onChange, children }) {
  return (
    <label className="flex items-start gap-2.5 text-xs leading-snug text-slate-600 cursor-pointer" data-testid={id}>
      <Checkbox checked={!!checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5 shrink-0" data-testid={`${id}-check`} />
      <span>{children}</span>
    </label>
  );
}

// Casillas del alta: las tres primeras son obligatorias y salen sin marcar; la de novedades es opcional y va aparte.
export function CasillasAlta({ valores, onChange, prefijo = "register" }) {
  const set = (k) => (v) => onChange({ ...valores, [k]: v });
  return (
    <div className="space-y-3" data-testid={`${prefijo}-casillas`}>
      <Casilla id={`${prefijo}-acepta-profesional`} checked={valores.acepta_profesional} onChange={set("acepta_profesional")}>
        Contrato como profesional, en el ejercicio de mi actividad. <span className="text-rose-500">*</span>
      </Casilla>
      <Casilla id={`${prefijo}-acepta-legales`} checked={valores.acepta_legales} onChange={set("acepta_legales")}>
        He leído y acepto los <Enlace to="/legal/terminos" id={`${prefijo}-enlace-terminos`}>Términos y condiciones</Enlace> y la{" "}
        <Enlace to="/legal/privacidad" id={`${prefijo}-enlace-privacidad`}>Política de privacidad</Enlace>. <span className="text-rose-500">*</span>
      </Casilla>
      <Casilla id={`${prefijo}-acepta-encargado`} checked={valores.acepta_encargado} onChange={set("acepta_encargado")}>
        He leído y acepto el{" "}
        <Enlace to="/legal/encargado-tratamiento" id={`${prefijo}-enlace-encargado`}>Contrato de encargado del tratamiento</Enlace>. <span className="text-rose-500">*</span>
      </Casilla>
      <div className="border-t border-slate-200 pt-3">
        <Casilla id={`${prefijo}-marketing`} checked={valores.marketing} onChange={set("marketing")}>
          Quiero recibir novedades y promociones por correo.
        </Casilla>
      </div>
    </div>
  );
}
